module.exports = "<p>\r\n  circular works!\r\n</p>\r\n<p>{{ happyText }}</p>\r\n<h1>Another text</h1>\r\n<button (click)='changeText()'>Change the text</button>\r\n\r\n<ol>\r\n    <li *ngFor=\"let todo of myTodos\">{{ todo }}</li>\r\n</ol>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/circular/circular.component.html
// module id = ../../../../../src/app/_components/circular/circular.component.html
// module chunks = 1